export default {
  "0000": "Undertaking for Collective Investment in Transferable Securities without legal personality",
  "1000": "Sole proprietorship",
  "2110": "Undivided ownership between natural persons",
  "2120": "Undivided ownership with legal entity",
  "2210": "De facto company between natural persons",
  "2220": "De facto company with legal entity",
  "2310": "Joint venture between natural persons",
  "2320": "Joint venture with legal entity",
  "2385": "Joint venture of liberal professions",
  "2400": "Trust",
  "2700": "Parish outside concordat zone",
  "2800": "Single VAT taxpayer",
  "2900": "Other private law entity without legal personality",
  "3110": "Representation or commercial agency of a foreign state or public body registered with the Trade and Companies Register (RCS)",
  "3120": "Foreign commercial company registered with the RCS",
  "3205": "International organization",
  "3210": "Foreign state, authority or public institution",
  "3220": "Foreign company not registered with the RCS",
  "3290": "Other legal entity under foreign law",
  "4110": "National public industrial or commercial institution with public accountant",
  "4120": "National public industrial or commercial institution without public accountant",
  "4130": "Public operator",
  "4140": "Local public industrial or commercial institution",
  "4150": "Industrial or commercial management entity of a local authority",
  "4160": "Institution Banque de France",
  "5191": "Mutual guarantee company",
  "5192": "Cooperative bank (Banque Populaire)",
  "5193": "Mutual maritime credit fund",
  "5194": "Mutual credit union (federal)",
  "5195": "Registered cooperative association (Alsace-Moselle local law)",
  "5196": "Savings and provident bank with cooperative form",
  "5202": "General partnership (SNC)",
  "5203": "Cooperative general partnership",
  "5306": "Limited partnership",
  "5307": "Cooperative limited partnership",
  "5308": "Partnership limited by shares",
  "5309": "Cooperative partnership limited by shares",
  "5310": "Special limited partnership (SLP)",
  "5370": "Liberal Professional Financial Holding Company in partnership limited by shares (SPFPL SCA)",
  "5385": "Professional limited partnership with share capital",
  "5410": "National limited liability company (SARL)",
  "5415": "Mixed economy limited liability company (SARL)",
  "5422": "Real estate SARL for commerce and industry (SICOMI)",
  "5426": "Real estate management SARL",
  "5430": "Land development and rural equipment SARL (SAFER)",
  "5431": "Mixed-interest agricultural SARL (SMIA)",
  "5432": "Collective-interest agricultural SARL (SICA)",
  "5442": "Property attribution SARL",
  "5443": "Construction cooperative SARL",
  "5451": "Consumer cooperative SARL",
  "5453": "Craft cooperative SARL",
  "5454": "Maritime interest cooperative SARL",
  "5455": "Transport cooperative SARL",
  "5458": "Production cooperative SARL (SCOP)",
  "5459": "Union of cooperative societies SARL",
  "5460": "Other cooperative SARL",
  "5470": "Liberal Professional Financial Holding Company in SARL form (SPFPL SARL)",
  "5485": "Professional limited liability company",
  "5499": "Limited liability company (unspecified)",
  "5505": "Employee-owned public limited company with board of directors",
  "5510": "National public limited company with board of directors",
  "5515": "Mixed economy public limited company with board of directors",
  "5520": "Fund with corporate form with board of directors",
  "5522": "Real estate SA for commerce and industry (SICOMI) with board of directors",
  "5525": "Real estate investment SA with board of directors",
  "5530": "Land development and rural equipment SA (SAFER) with board of directors",
  "5531": "Mixed-interest agricultural SA (SMIA) with board of directors",
  "5532": "Collective-interest agricultural SA (SICA) with board of directors",
  "5542": "Property attribution SA with board of directors",
  "5543": "Construction cooperative SA with board of directors",
  "5546": "Social housing SA (HLM) with board of directors",
  "5547": "Production cooperative SA (HLM) with board of directors",
  "5548": "Mortgage credit SA with board of directors",
  "5551": "Consumer cooperative SA with board of directors",
  "5552": "Retailer cooperative SA with board of directors",
  "5553": "Craft cooperative SA with board of directors",
  "5554": "Maritime interest cooperative SA with board of directors",
  "5555": "Transport cooperative SA with board of directors",
  "5558": "Production cooperative SA (SCOP) with board of directors",
  "5559": "Union of cooperative companies SA with board of directors",
  "5560": "Other cooperative SA with board of directors",
  "5570": "Liberal Professional Financial Holding Company in SA form with board of directors (SPFPL SA)",
  "5585": "Professional corporation in SA form with board of directors",
  "5599": "SA with board of directors (unspecified)",
  "5605": "Employee-owned public limited company with executive board",
  "5610": "National public limited company with executive board",
  "5615": "Mixed economy public limited company with executive board",
  "5620": "Fund with corporate form with executive board",
  "5622": "Real estate SA for commerce and industry (SICOMI) with executive board",
  "5625": "Real estate investment SA with executive board",
  "5630": "Land development and rural equipment SA (SAFER) with executive board",
  "5631": "Mixed-interest agricultural SA (SMIA) with executive board",
  "5632": "Collective-interest agricultural SA (SICA) with executive board",
  "5642": "Property attribution SA with executive board",
  "5643": "Construction cooperative SA with executive board",
  "5646": "Social housing SA (HLM) with executive board",
  "5647": "Production cooperative SA (HLM) with executive board",
  "5648": "Mortgage credit SA with executive board",
  "5651": "Consumer cooperative SA with executive board",
  "5652": "Retailer cooperative SA with executive board",
  "5653": "Craft cooperative SA with executive board",
  "5654": "Maritime interest cooperative SA with executive board",
  "5655": "Transport cooperative SA with executive board",
  "5658": "Production cooperative SA (SCOP) with executive board",
  "5659": "Union of cooperative companies SA with executive board",
  "5660": "Other cooperative SA with executive board",
  "5670": "Liberal Professional Financial Holding Company in SA form with executive board (SPFPL SA)",
  "5685": "Professional corporation in SA form with executive board",
  "5699": "SA with executive board (unspecified)",
  "5710": "Simplified joint-stock company (SAS)",
  "5770": "Liberal Professional Financial Holding Company in SAS form (SPFPL SAS)",
  "5785": "Professional simplified joint-stock company",
  "5800": "European company (Societas Europaea)",
  "6100": "Savings and Provident Fund",
  "6210": "European Economic Interest Grouping (EEIG)",
  "6220": "Economic Interest Grouping (EIG)",
  "6316": "Agricultural Equipment Cooperative (CUMA)",
  "6317": "Agricultural Cooperative",
  "6318": "Union of Agricultural Cooperatives",
  "6411": "Mutual Insurance Company",
  "6511": "Interprofessional Ambulatory Care Societies",
  "6521": "Real Estate Investment Trust (SCPI)",
  "6532": "Civil Society for Collective Agricultural Interest (SICA)",
  "6533": "Agricultural Joint Operating Group (GAEC)",
  "6534": "Agricultural Land Grouping",
  "6535": "Agricultural Land Holding Group",
  "6536": "Forestry Group",
  "6537": "Pastoral Group",
  "6538": "Land and Rural Group",
  "6539": "Real Estate Civil Society",
  "6540": "Real Estate Investment Civil Society (SCI)",
  "6541": "Construction and Sale Real Estate Civil Society",
  "6542": "Attribution Civil Society",
  "6543": "Construction Cooperative Civil Society",
  "6544": "Progressive Ownership Real Estate Civil Society",
  "6551": "Consumer Cooperative Civil Society",
  "6554": "Maritime Interest Cooperative Civil Society",
  "6558": "Medical Cooperative Civil Society",
  "6560": "Other Cooperative Civil Society",
  "6561": "Professional Civil Partnership of Lawyers",
  "6562": "Professional Civil Partnership of Supreme Court Lawyers",
  "6563": "Professional Civil Partnership of Appeal Lawyers",
  "6564": "Professional Civil Partnership of Bailiffs",
  "6565": "Professional Civil Partnership of Notaries",
  "6566": "Professional Civil Partnership of Auctioneers",
  "6567": "Professional Civil Partnership of Commercial Court Clerks",
  "6568": "Professional Civil Partnership of Legal Advisors",
  "6569": "Professional Civil Partnership of Statutory Auditors",
  "6571": "Professional Civil Partnership of Doctors",
  "6572": "Professional Civil Partnership of Dentists",
  "6573": "Professional Civil Partnership of Nurses",
  "6574": "Professional Civil Partnership of Physiotherapists",
  "6575": "Professional Civil Partnership of Medical Laboratory Directors",
  "6576": "Professional Civil Partnership of Veterinarians",
  "6577": "Professional Civil Partnership of Surveyors",
  "6578": "Professional Civil Partnership of Architects",
  "6585": "Other Professional Civil Partnership",
  "6589": "Partnership for the Sharing of Resources (SCM)",
  "6595": "Local Mutual Credit Fund",
  "6596": "Mutual Agricultural Credit Fund",
  "6597": "Agricultural Operating Civil Society",
  "6598": "Limited Liability Agricultural Enterprise (EARL)",
  "6599": "Other Civil Society",
  "6901": "Other private law entity registered with the Trade and Companies Register",
  "7111": "Constitutional authority",
  "7112": "Independent administrative or public authority",
  "7113": "Ministry",
  "7120": "Central service of a ministry",
  "7150": "Ministry of Defense service",
  "7160": "National-level decentralized service of a ministry (excluding Defense)",
  "7171": "Interregional or regional decentralized State service",
  "7172": "Interdepartmental or departmental decentralized State service",
  "7179": "Other territorial decentralized State service",
  "7190": "National school without legal personality",
  "7210": "Municipality or new municipality",
  "7220": "Department",
  "7225": "Overseas collectivity or territory",
  "7229": "Other local authority",
  "7230": "Region",
  "7312": "Associated or delegated municipality",
  "7313": "Municipality section",
  "7314": "Urban unit",
  "7321": "Authorized syndicate association",
  "7322": "Urban land association",
  "7323": "Land consolidation association",
  "7331": "Local public educational institution",
  "7340": "Metropolitan hub",
  "7341": "Municipal sector",
  "7342": "Urban district",
  "7343": "Urban community",
  "7344": "Metropolis",
  "7345": "Inter-municipal syndicate with multiple purposes (SIVOM)",
  "7346": "Community of municipalities",
  "7347": "Community of towns",
  "7348": "Urban area community",
  "7349": "Other local public cooperation institution or agreement",
  "7351": "Interdepartmental institution or agreement",
  "7352": "Interregional institution or agreement",
  "7353": "Inter-municipal syndicate with a single purpose (SIVU)",
  "7354": "Closed mixed syndicate",
  "7355": "Open mixed syndicate",
  "7356": "Syndicate commission managing joint municipal property",
  "7357": "Territorial and rural balance hub (PETR)",
  "7361": "Municipal Social Action Center",
  "7362": "School Fund",
  "7363": "Municipal Credit Fund",
  "7364": "Hospital institution",
  "7365": "Inter-hospital syndicate",
  "7366": "Local public social and medico-social institution",
  "7367": "Inter-municipal Social Action Center (CIAS)",
  "7371": "Public low-rent housing office (OPHLM)",
  "7372": "Departmental Fire and Rescue Service (SDIS)",
  "7373": "Local public cultural institution",
  "7378": "Administrative management body of a local authority",
  "7379": "Other local public administrative institution",
  "7381": "Chamber of commerce or trade organization",
  "7382": "National public institution with central administration role",
  "7383": "National public institution of scientific, cultural or professional character",
  "7384": "Other national public educational institution",
  "7385": "Other national public administrative institution with limited territorial jurisdiction",
  "7389": "National public administrative institution",
  "7410": "Public Interest Group (GIP)",
  "7430": "Public religious institution of Alsace-Lorraine",
  "7450": "Administrative public institution, club or facility within the armed forces",
  "7470": "Publicly managed health cooperation group",
  "7490": "Other administrative legal entity",
  "8110": "General Social Security scheme",
  "8120": "Special Social Security scheme",
  "8130": "Complementary retirement institution",
  "8140": "Agricultural Social Security (MSA)",
  "8150": "Health insurance scheme for non-agricultural self-employed persons",
  "8160": "Pension scheme outside general Social Security",
  "8170": "Unemployment insurance scheme",
  "8190": "Other social welfare scheme",
  "8210": "Mutual insurance association",
  "8250": "Agricultural mutual insurance",
  "8290": "Other mutual organization",
  "8310": "Corporate Social and Economic Committee",
  "8311": "Establishment-level Social and Economic Committee",
  "8410": "Employee union",
  "8420": "Employer union",
  "8450": "Professional order or equivalent",
  "8470": "Industrial technical center or professional economic development committee",
  "8490": "Other professional organization",
  "8510": "Provident institution",
  "8520": "Supplementary pension institution",
  "9110": "Condominium syndicate",
  "9150": "Free syndicate association",
  "9210": "Unregistered association",
  "9220": "Declared association",
  "9221": "Declared association for economic reintegration",
  "9222": "Intermediary association",
  "9223": "Employers group",
  "9224": "Association of lawyers with individual professional liability",
  "9230": "Declared association recognized as being of public utility",
  "9240": "Religious congregation",
  "9260": "Association under local law (Bas-Rhin, Haut-Rhin and Moselle)",
  "9300": "Foundation",
  "9900": "Other private law legal entity",
  "9970": "Privately managed health cooperation group"
};
  